import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Card } from '../ui/Card';
import { Toggle } from '../ui/Toggle';
import type { LeadSource } from '../../types';
interface SourceListProps {
  sources: LeadSource[];
  selectedId: string;
  onSelect: (id: string) => void;
  onToggle: (id: string, enabled: boolean) => void;
}
export function SourceList({
  sources,
  selectedId,
  onSelect,
  onToggle
}: SourceListProps) {
  return <Card className="overflow-hidden" data-id="element-83" data-mp="1biog9tu530hk">
      <div className="border-b border-ink-200 px-5 py-4" data-id="element-84" data-mp="1bfiqsdhllwlb">
        <h2 className="text-sm font-semibold text-ink-900" data-id="element-85" data-mp="16k3ehpz8o8r0">Lead Sources</h2>
        <p className="mt-0.5 text-xs text-ink-500" data-id="element-86" data-mp="1kagn7ujyfrhe">Select a source to configure its cadence</p>
      </div>
      <ul className="divide-y divide-ink-200" data-id="element-87" data-mp="1fj8aopnbvq00">
        {sources.map(source => {
        const active = source.id === selectedId;
        const activeRules = source.rules.filter(r => r.enabled).length;
        return <li key={source.id} data-id="element-88" data-mp="nrsqt3d5ohdh">
              <div className={twMerge('flex items-center gap-3 px-5 py-3.5 transition-colors', active ? 'bg-brand-50/70' : 'hover:bg-ink-50')} data-id="element-89" data-mp="1xfdgxjrwticw">
                <button type="button" onClick={() => onSelect(source.id)} className="min-w-0 flex-1 text-left" aria-current={active ? 'true' : undefined} data-id="element-90" data-mp="274x2wyax5sbz">
                  <span className="flex items-center gap-2" data-id="element-91" data-mp="1eim3vs2ynzha">
                    <span className={twMerge('h-1.5 w-1.5 rounded-full', source.enabled ? 'bg-emerald-500' : 'bg-ink-300')} aria-hidden="true" data-id="element-92" data-mp="1jgnjg316hgo0" />
                    <span className={twMerge('truncate text-sm font-medium', source.enabled ? 'text-ink-900' : 'text-ink-400')} data-id="element-93" data-mp="2zudu5smsz36m">
                      {source.name}
                    </span>
                  </span>
                  <span className="tabular mt-0.5 block text-xs text-ink-500" data-id="element-94" data-mp="zr34tobtjs05">
                    {activeRules} cadence rule{activeRules === 1 ? '' : 's'} ·{' '}
                    {source.monthlyVolume}/mo
                  </span>
                </button>
                <Toggle checked={source.enabled} onChange={checked => onToggle(source.id, checked)} label={`${source.enabled ? 'Disable' : 'Enable'} ${source.name}`} data-id="element-95" data-mp="lzol1fa37ms1" />
              </div>
            </li>;
      })}
      </ul>
    </Card>;
}